import React from 'react';
import './HelpCenter.css'

const HelpCenter = () => {
    return (
        <div>
            <h1>Help page cumming soon</h1>
        </div>
    );
};

export default HelpCenter;